"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.en = void 0;
exports.en = {
    cancel: "Cancel",
    close: "Close",
    ok: "Ok",
};
//# sourceMappingURL=en.js.map